import actions from './actions';

const initState = {
    data: [],
};

export default function SubTaskReducer(state = initState, action) {
    switch (action.type) {
        case actions.SubTask_SUCCESS:
            return {
                ...state,
                data: action.payload.data
            };
        default:
            return state;
    }
}
